export default "__VITE_ASSET__DsTFiWN$__"